import { createAsyncThunk, createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../../app/store';
import { fetchCount } from './sessionAPI';
import { Nr, GError } from '../../../util/types';

export interface DiscordUser {
	id: string,
	avatar: string | null,
	username: string,
	discriminator: string,
}

export interface AuthRequest {
	code: string,
	state: string,
}

export interface SigninFormRequest {
	name: string,
	email: string,
	given_name: string,
	family_name: string,
	password: string,
	password_confirmation: string,
	i18n: string,
	website: string,
	location: string,
	description: string,
}

/*
export interface signinFormResponseError {
	username: GError | null,
	email: GError | null,
	password: GError | null,
	password_confirmation: GError | null,
	website: GError | null,
	location: GError | null,
	description: GError | null,
	errors: [GError],
}
// */

export interface SignupFormRequest {
	name: string,
	email: string,
	given_name: string,
	family_name: string,
	password: string,
	password_confirmation: string,
	i18n: string,
	website: string,
	location: string,
	description: string,
}

export interface SignupFormResponse {
	data: Session | null,
	errors: [GError],
}

export interface signinFormResponse {
	bio: string | null,
	email: string,
	image: string | null,
	token: string,
	username: string,
}

export interface LoginFormResponse {
	user: signinFormResponse,
}

export interface LoggedData {
	user: Nr;
	organization: Nr | null;
	log_time: string;
	exp_time: string;
}

export interface Session {
	user: Nr;
	organization: Nr | null;
	log_time: string;
	exp_time: string;
}

export interface GoogleProfileData {
	id: string;
	name: string;
	given_name: string;
	family_name: string;
	locale: string;
	picture: string;
	user: Nr | null;
}

export interface GoogleProfile {
	GoogleProfile: GoogleProfileData;
}

export interface AuthData {
	session: Nr;
}

export interface InitResponse {
	session: Session | null;
	oauth_user: GoogleProfile | null;
	log_time: number;
	exp_time: number;
}

export interface SessionState {
	session: Session | null;
	oauth_user: GoogleProfile | null;
	lastSessionCheck: number | null;
}

const initialState: SessionState = {
/*
  logged: {
	  //token: 'thisistoken',
	  exp: 1692526118891,
	  user: {
		  id: 'this-an-id',
		  name: 'this-a-name',
	  },
	  organization: null,
  },
 // */
  session: null,
  oauth_user: null,
  //lastSessionCheck: 1692526118891,
  lastSessionCheck: null,
};


// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const incrementAsync = createAsyncThunk(
  'counter/fetchCount',
  async (amount: number) => {
    const response = await fetchCount(amount);
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
	login: (state, action: PayloadAction<Session>) => {
		console.log('action', action);
		state.session = action.payload;
	},
	init: (state, action: PayloadAction<InitResponse | null>) => {
		if (action.payload) {
			console.log("init action:", action.payload);
			state.session =
				action.payload.session;
			state.oauth_user = action.payload.oauth_user;
		} else {
			state = state;
		}
		//state = state;
	},
	signup: (state, action: PayloadAction<SignupFormResponse>) => {
		console.log('action', action);
		state.session = action.payload.data;
	},
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
	  /*
  extraReducers: (builder) => {
    builder
      .addCase(incrementAsync.pending, (state) => {
        state.sessionStatus = 'checking';
      })
      .addCase(incrementAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.value += action.payload;
      })
      .addCase(incrementAsync.rejected, (state) => {
        state.status = 'failed';
      })
	  .addCase(loginResponse, (state) => {
		  state
	  })
	  ;
  },
      // */
});

export const { init, login, signup } = sessionSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectLogged = (state: RootState) => state.session.session;
// https://stackoverflow.com/questions/67532294/add-paramater-to-redux-useselector-hook
export const selectIsAuthenticated = (now: Date) => (state: RootState) => {
	if (state.session.session) {
		let d = new Date(state.session.session.exp_time);
		if (now.getTime() < d.getTime()) {
			return true
		} else {
			return false
		}
		return true;
	}	else {
		return false;
	}
};

export const selectLastSessionChecked = (state: RootState) =>
state.session.lastSessionCheck;
export const selectIsAuthChecked = (now: number) => (state: RootState) => {
	// 1209600000 = 14 days
	if (state.session.lastSessionCheck
		&& now < state.session.lastSessionCheck + 1209600000) {
		return true;
	} else {
		return true; // replace this by false when <App /> is done
	}
};

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
/*
export const incrementIfOdd =
  (amount: number): AppThunk =>
  (dispatch, getState) => {
    const currentValue = selectCount(getState());
    if (currentValue % 2 === 1) {
      dispatch(incrementByAmount(amount));
    }
  };
 // */

export default sessionSlice.reducer;
